module.exports = "/_next/static/images/truck-3b80463ce4e612b331a16dc1592ebed8.svg";